import { useState } from 'react';

import { styled } from '@mui/material';

import { Typography } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { ViewPreview } from '../../../../components/ViewPreview';
import { PrototypeConfusions } from '../../../../types';

import { ViewDetails } from './components/ViewDetails';
import { Metrics } from './components/Metrics';
import { Viewer } from '../../../../components/Overview/components/Confusions/components/Viewer';

const StyledPreview = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(20),
  height: '40vh',
}));

export type PreviewProps = {
  confusions: PrototypeConfusions;
};

export const Preview = ({ confusions }: PreviewProps) => {
  const { t } = useI18n();

  const { highest, avgPageDuration, clicksForConfussions } = confusions;
  const [activeConfusion, setActiveConfusion] = useState(0);

  return (
    <>
      <Typography variant="body1">
        {t('prototypes:suggested_improvements.description', {
          count: highest.length,
        })}
      </Typography>
      <StyledPreview>
        <Viewer
          onActivate={setActiveConfusion}
          slides={highest.map((confussion, index) => (
            <ViewPreview
              persona="default"
              size="large"
              key={confussion[0]}
              pageId={confussion[1].pageId}
              partials={confussion[1].partials}
              clicks={clicksForConfussions[index]}
              image={confussion[1].image}
              width={confussion[1].width}
              height={confussion[1].height}
            />
          ))}
        />
      </StyledPreview>

      <ViewDetails
        name={highest[activeConfusion][1].name || '-'}
        humanParticipants={highest[activeConfusion][1].humanParticipants}
        simulatedParticipants={
          highest[activeConfusion][1].simulatedParticipants
        }
      />

      <Metrics
        confusion={highest[activeConfusion][1]}
        avgPageDuration={avgPageDuration}
      />
    </>
  );
};
